var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('Navbar'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('main',{staticClass:"col-md-12 ml-sm-auto col-lg-12 px-4 pb-5 mt-5 p-5",attrs:{"role":"main"}},[_c('Navigation')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }